import { render, staticRenderFns } from "./InteractTab.vue?vue&type=template&id=3c3a00c0&scoped=true"
import script from "./InteractTab.vue?vue&type=script&lang=js"
export * from "./InteractTab.vue?vue&type=script&lang=js"
import style0 from "./InteractTab.vue?vue&type=style&index=0&id=3c3a00c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c3a00c0",
  null
  
)

export default component.exports